<div class="mz-trend-chart">
  <div class="chartLegend" [hidden]="viewType != 'chart'">
    <h2 class="sub-header">ADJUST DISPLAY</h2>
    <p class="sub-header-desc">Click to hide or hover to highlight</p>
    <cdk-virtual-scroll-viewport itemSize="50" class="legend-items">
      <h3 class="legend-item" *cdkVirtualFor="let series of chartData">
        <button
          mat-button
          [ngClass]="{
            'highlighted-btn':
              highlightedItem && highlightedItem.name == series.name,
            'hidden-btn': !series.visible
          }"
          (mouseenter)="highlight(series)"
          (mouseleave)="unhighlight(series)"
          (click)="toggleSeriesVisibility(series.name)"
          class="legend-btn"
        >
          <span [ngClass]="{ 'hidden-item': !series.visible }">
            <ng-container
              *ngIf="
                !(
                  series.compare_by &&
                  series.compare_by != 'Overall' &&
                  selectedSubArea != 'Overall'
                )
              "
            >
              {{ series.name }}
            </ng-container>
            <ng-container
              *ngIf="
                series.compare_by &&
                series.compare_by != 'Overall' &&
                selectedSubArea != 'Overall'
              "
            >
              <div class="content-title">{{ series.content }}</div>
              <div class="compare-by-title">{{ series.compare_by }}</div>
            </ng-container>
          </span>
        </button>
      </h3>
    </cdk-virtual-scroll-viewport>
  </div>
  <div id="chartDiv" class="chart" *ngIf="viewType == 'chart'">
    <mz-info-message
      *ngIf="chartData && chartData.length >= 8 && !isHiddenInLocalStorage()"
      [type]="tooMuchData ? 'tooMuchData' : 'trend'"
      (switchToTable)="changeViewTypeEvent.emit({ value: 'table' })"
      (triggerExport)="exportCSV.emit()"
      (hideMZInfoMessage)="hideMZInfoMessage()"
      [ngClass]="{ 'too-much-data-info': tooMuchData }"
    ></mz-info-message>
    <mat-progress-spinner
      class="modal-spinner"
      [diameter]="75"
      [mode]="'indeterminate'"
      *ngIf="loading"
    >
    </mat-progress-spinner>
    <p
      *ngIf="!loading && (!chartData || chartData.length == 0)"
      class="load-info-text"
    >
      No data available
    </p>
    <line-expanded
      #chart
      [chartData]="chartData"
      [categories]="categories"
      [dataPrefix]="data.lightbox.dataPrefix"
      [dataSuffix]="data.lightbox.dataSuffix"
      [min]="min"
      [max]="max"
      [roundTo]="data.lightbox.roundTo"
      [title]="data.lightbox.title"
      [tooltipDescriptor]="tooltipDescriptor"
      [filterByText]="filterByText"
      [contentText]="contentText"
      [compareByCategory]="selectedCompareBy"
      [noComparisonText]="noComparisonText"
      (lineMousedOut)="toggleLegendHighlight($event, false)"
      (lineMousedOver)="toggleLegendHighlight($event, true)"
      [hidden]="loading"
      class="mz-line-exapnded-chart"
      *ngIf="
        !tooMuchData &&
        chartData &&
        chartData[0] &&
        chartData[0].data &&
        (chartData.length > 0 || chartData[0].data.length > 0)
      "
    ></line-expanded>
  </div>
</div>
